export default __webpack_public_path__ + "static/media/donggukULogo.6711a5b8.jpg";